  export const VERIFY_USER_REQUEST =
  "VERIFY_USER_REQUEST";

    export const RESEND_OTP_REQUEST =
  "RESEND_OTP_REQUEST";

   export const VERIFY_OTP_REQUEST =
  "VERIFY_OTP_REQUEST";

     export const SAVE_USER_DETAILS_REQUEST =
  "SAVE_USER_DETAILS_REQUEST";

       export const LOGOUT_USER_DETAILS_REQUEST =
  "LOGOUT_USER_DETAILS_REQUEST";

        export const LOGOUT_USER_DETAILS_SUCCESS =
  "LOGOUT_USER_DETAILS_SUCCESS";

       export const COMPANY_TYPE_REQUEST =
  "COMPANY_TYPE_REQUEST";
       export const SAVE_USER_DETAILS_SUCCESS =
  "SAVE_USER_DETAILS_SUCCESS";
  


        export const EXPERIENCED_AS_IN_TYPE_REQUEST =
  "EXPERIENCED_AS_IN_TYPE_REQUEST";

          export const LOGIN_USER_REQUEST =
  "LOGIN_USER_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SET_NEW_PASSWORD_REQUEST = "SET_NEW_PASSWORD_REQUEST";
export const SET_NEW_PASSWORD_SUCCESS = "SET_NEW_PASSWORD_SUCCESS";
export const UPDATE_AUTH_USER_DETAILS = "UPDATE_AUTH_USER_DETAILS";


  
  
